import React from 'react';
import { FramedImage } from '@doveit/lego';
import * as styles from './FramedImageRenderer.style';

export interface FramedImageRendererProps {
  src?: string,
  alt?: string,
}

const FramedImageRenderer: React.FC<FramedImageRendererProps> = ({
  src,
  alt,
}) => (
  <div css={styles.wrapper}>
    <FramedImage
      src={src}
      alt={alt}
    />
  </div>
);

export default FramedImageRenderer;
